import { PopupMenuItem } from './PopupMenuItem.component';
export { PopupMenuItem } from './PopupMenuItem.component';

export const PopupMenuTrigger = (props: React.ComponentProps<typeof PopupMenuItem>) =>
  PopupMenuItem({ keepOpenOnClick: true, ...props });
